import AdditionalDocumentsCell from './container';

export default AdditionalDocumentsCell;
